/**
 * Minutes as the dashboard says them: "45m", "2h", "1h 30m".
 *
 * Exactly the Vue console's rule — hours only once there is a whole one, and
 * the minutes dropped when they are zero.
 */
export function formatSessionLength(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest > 0 ? `${hours}h ${rest}m` : `${hours}h`;
}
